class UploadStatusIcon extends HTMLElement {
  static get observedAttributes() {
    return ['hasbeenuploaded'];
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open' }); // Attach a shadow DOM to the custom element.
  }

  connectedCallback() {
    this.render(); // Initial render when the component is added to the DOM.
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this.render(); // Rerender the component when the observed attribute changes.
  }

  render() {
    const hasBeenUploaded = this.getAttribute('hasbeenuploaded') === 'true';
    this.shadowRoot.innerHTML = hasBeenUploaded
      ? `<box-icon name="check" color="green" size="md" pull="right"></box-icon>`
      : `<box-icon name="x" color="red" size="md" pull="right"></box-icon>`;
  }
}

// Define the new element
customElements.define('upload-status-icon', UploadStatusIcon);
